import {
  PageGen,
  PdfRect,
  PdfUnit,
  PdfBrush,
  PdfColor,
  PdfPen,
  PdfPoint,
  ETextAlign,
} from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaBlue implements IColorSchema {
  readonly name = 'Blue';

  private marginAround = PdfUnit.FromMillimeters(1);
  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private marginTopFirst = PdfUnit.FromMillimeters(10);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);

  private pageBackgroundColor = PdfColor.fromRgb(226, 244, 253);
  private pageMarginColor = PdfColor.fromRgb(115, 208, 246);
  private borderColor = PdfColor.fromRgb(0, 175, 239);

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    page.drawRectangle(null, new PdfBrush(this.pageBackgroundColor), rect);
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `- ${pageNumber} -`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    const aroundPen = new PdfPen(this.borderColor, 1.5);
    const around = new PdfRect(
      rect.x,
      rect.y + this.sizeTopHeader / 2,
      rect.width,
      rect.height - this.sizeTopHeader / 2
    );
    page.drawRoundedRectangle(aroundPen, PdfBrush.White, around, PdfUnit.FromMillimeters(5));

    const top = (this.sizeTopHeader - this.sizeTopTitle) / 2;
    let left = rect.x + this.marginTopFirst;

    if (counter) {
      const s1 = page.measureString(counter, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);

      page.drawRectangle(new PdfPen(this.borderColor, 1.5), new PdfBrush(this.pageMarginColor), r);
      page.drawString(counter, font, PdfBrush.Black, null, r, ETextAlign.Center);

      left += r.width + this.marginTop;
    }

    if (title) {
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);

      page.drawRectangle(new PdfPen(this.borderColor, 1.5), new PdfBrush(this.pageMarginColor), r);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.Center);
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    page.drawRectangle(null, new PdfBrush(this.pageBackgroundColor), rect);
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x + this.marginAround,
      rect.y + this.sizeTopHeader,
      rect.width - 2 * this.marginAround,
      rect.height - this.sizeTopHeader - this.marginAround
    );
  }
}
